import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchProviders } from '../api/catalog';
import type { Provider } from '../api/types';
import { EmptyState } from '../components/EmptyState';

export function ProvidersPage() {
  const { t } = useTranslation(['games']);
  const [providers, setProviders] = useState<Provider[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const data = await fetchProviders();
        if (!cancelled) setProviders(data.providers);
      } catch {
        if (!cancelled) setProviders([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    void load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page">
      <h1>{t('providers', { defaultValue: 'Providers' })}</h1>
      {loading ? (
        <div className="skeleton" style={{ minHeight: 160 }} />
      ) : providers.length === 0 ? (
        <EmptyState
          title={t('catalogEmpty', { defaultValue: 'No providers synchronized' })}
          body={t('catalogEmptyHint', {
            defaultValue: 'Providers appear after Aggregator.gg catalog sync with a valid API key.',
          })}
        />
      ) : (
        <ul className="provider-list">
          {providers.map((p) => (
            <li key={p.code}>
              <strong>{p.name}</strong>
              <span>{p.code}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
